import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { OUTCOME_ACCOUNT_TYPE } from "./outcomes.constants";

export function useOutcomeStructures() {
  return useAccountTypeStructures(OUTCOME_ACCOUNT_TYPE);
}
